import type { HttpGet, HttpRequest } from '@/shared/infra/http'
import type { MyEntitlements } from '@/shared/domain'
import type { LoadMyEntitlements } from '@/modules/auth/use-cases'

export class EdgeLoadMyEntitlementsRepository {
  constructor(private readonly httpClient: HttpGet) {}

  execute: LoadMyEntitlements = async () => {
    const request: HttpRequest<never> = { url: '/entitlements/me' }
    return this.httpClient.get<MyEntitlements>(request)
  }
}
